import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { dishesSteps } from 'common/constants/menu';

import {
  getSpecialMenu,
  updateOrCreateRequest,
  getByIdRequest,
  changeFormStep,
  resetErrors,
  deleteSpecialMenu,
  resetListData,
  changeSpecialMenuPosition,
} from './actions';
import {
  specialMenuListDataSelector,
  specialMenuStepSelector,
  specialMenuCompletedStepsSelector,
  createOrUpdateErrorsSelector,
  deleteInProcessSelector,
  createOrUpdateInProcessSelector,
  currentItemLoadingSelector,
  currentItemSelector,
} from './selectors';

export const useSpecialMenu = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const listData = useSelector(specialMenuListDataSelector);
  const completedSteps = useSelector(specialMenuCompletedStepsSelector);
  const step = useSelector(specialMenuStepSelector);
  const createOrUpdateErrors = useSelector(createOrUpdateErrorsSelector);
  const deleteInProcess = useSelector(deleteInProcessSelector);
  const createOrUpdateInProcess = useSelector(createOrUpdateInProcessSelector);
  const currentItem = useSelector(currentItemSelector);
  const currentItemLoading = useSelector(currentItemLoadingSelector);

  const handleGetSpecialMenu = () => {
    dispatch(getSpecialMenu());
  };

  const handleGetByIdSpecialMenu = (id) => {
    dispatch(getByIdRequest({ id }));
  };

  const handleResetErrors = () => {
    if (createOrUpdateErrors) {
      dispatch(resetErrors());
    }
  };

  const handleChangeDishStep = (nextStep) => {
    dispatch(
      changeFormStep({
        step: nextStep,
        completedSteps: [...completedSteps, nextStep],
      }),
    );
  };

  const handleResetSteps = () => {
    dispatch(
      changeFormStep({
        step: dishesSteps.first,
        completedSteps: [dishesSteps.first],
      }),
    );
  };

  const handleResetData = () => {
    dispatch(resetListData());
  };

  const handleUpdateOrCreate = (data, id) => {
    dispatch(updateOrCreateRequest({ formData: data, history, id }));
  };

  const handleDeleteSpecialMenu = (id) => {
    dispatch(deleteSpecialMenu({ id, history }));
  };

  const handleChangeSpecialMenuPosition = (id, position, originalPosition) => {
    dispatch(changeSpecialMenuPosition({ id, position, originalPosition }));
  };

  return {
    handleResetErrors,
    handleGetSpecialMenu,
    handleUpdateOrCreate,
    listData,
    handleGetByIdSpecialMenu,
    completedSteps,
    step,
    handleChangeDishStep,
    handleResetSteps,
    createOrUpdateErrors,
    handleDeleteSpecialMenu,
    deleteInProcess,
    createOrUpdateInProcess,
    currentItem,
    currentItemLoading,
    handleResetData,
    handleChangeSpecialMenuPosition,
  };
};
